import {gsap, Linear} from "gsap";

import {useI18n} from "vue-i18n";

export default{
    name: "Header",
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    props: {
        pathImageBck: {
            type: String, Number
        },
        pathImageVisual: {
            type: String
        },
        visual: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.initAnimation();
    },
    methods: {
        /**
         * Init animation element header
         */
        initAnimation(){
            const headerWrapper = this.$refs.headerVisual;

            const leftElement = '.' + headerWrapper.children[0].className;
            let rightElement = '';
            if(headerWrapper.childElementCount === 2){
                rightElement = '.' + headerWrapper.children[1].className;
            }

            gsap.set(leftElement, {x: 100, alpha: 0});

            if(rightElement){
                gsap.set(rightElement, {x: -100, alpha: 0});
            }

            setTimeout(() => {
                gsap.to(leftElement,  {x: 0, alpha: 1, ease: Linear.easeOut});
                if(rightElement){
                    gsap.to(rightElement,  {x: 0, delay: 0.1, alpha: 1, ease: Linear.easeOut});
                }
            }, 800);
        }
    }
}
